<template>
	<div>
		<div class="tree-table-grid theader"
			:style="`border-color:${$appColors.gray}`"
		>
			<h4
				class="column-title"
				:style="`color:${$appColors.primary}`"
			>NONMBRE</h4>
			<h4
				class="column-title"
				:style="`color:${$appColors.primary}`"
			>TIPO</h4>
			<h4
				class="column-title"
				:style="`color:${$appColors.primary}`"
			>ACCIONES</h4>
		</div>
		<TreeNodesDl
			class="tree-node"
			children="entities"
			text="name"
			:indent="12"
			:nodes="treeData"
		>
			<template slot-scope="{ node, isOpen }">
				<div class="tree-table-grid tbody"
					:style="`color:${$appColors.info}`"
				>
					<div class="tree-title">
						<app-tooltip-button
							v-if="node.entities.length > 0"
							:icon="isOpen ? 'remove_circle_outline' : 'add_circle_outline'"
							text="Agregar"
							color="primary"
						/>
						<h5>{{node.name}}</h5>
					</div>
					<span class="tool-type"
						:style="`border-color:${$appColors.gray}`"
					>tipo</span>
					<div class="tool-action">
						<app-tooltip-button
							icon="add_circle_outline"
							text="Agregar"
							color="primary"
							@click-icon="addItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
							text="Editar"
							@click-icon="editItem($event, node, isOpen)"
						/>
						<app-tooltip-button
							img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
							text="Eliminar"
						/>
					</div>
				</div>
			</template>
		</TreeNodesDl>
	</div>
</template>

<script>
import TreeNodesDl from 'tree-nodes-dl';

function editItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	const { number, name, flagQuestion, id } = node;
	const params = { number, name, flagQuestion, id };
	this.goTo('new-level-form', { params });
}

function addItem(e, node, isOpen) {
	if (isOpen) {
		e.stopPropagation();
	}
	this.openNewLevelForm(node);
}

function openNewLevelForm(node) {
	const params = { number: node.number, hierarchyFatherId: node.id };
	this.goTo('new-level-form', { params });
}

export default {
	name: 'tree-tool-table',
	components: {
		TreeNodesDl,
	},
	methods: {
		addItem,
		editItem,
		openNewLevelForm,
	},
	props: {
		treeData: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.theader {
	border-bottom: 1px solid;
	border-top: 1px solid;
	padding: 8px 0;
}

.tree-table-grid {
	align-items: center;
	display: grid;
	grid-template-columns: 1fr 150px 150px;

	.column-title {
		font-family: font(bold);
		text-align: center;
	}

	.tree-title {
		align-items: center;
		display: flex;
	}
}

.tree-node {

	.tbody {
		padding-left: 15px;
	}

	.tool-type {
		border-left: 1px solid;
		border-right: 1px solid;
		padding: 10px 0;
		padding-left: 10px;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.tool-action {
		align-items: center;
		display: flex;
		justify-content: space-evenly;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/tree-tool-table.vue